<template>
  <div class="pdf-upload">
    <a-upload
      :file-list="fileList"
      :accept="'.pdf'"
      :before-upload="beforeUpload"
      :customRequest="handleChange"
      @change="changeFile"
      @preview="handlePreview"
      :remove="handleRemove"
      :disabled="disabled"
    >
      <a-button v-if="fileList.length < 1 && !disabled">
        <a-icon type="upload" /> 上传PDF
      </a-button>
    </a-upload>
    <!-- PDF预览弹窗 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      :width="900"
      @cancel="handleCancel"
      title="PDF预览"
    >
      <div style="text-align: center; margin-bottom: 10px">
        <a-button
          type="link"
          :href="previewUrl"
          target="_blank"
          style="margin-right: 10px"
        >
          <a-icon type="download" />下载PDF
        </a-button>
        <a-button type="link" @click="openInNewWindow">
          <a-icon type="export" />在新窗口打开
        </a-button>
      </div>
      <iframe
        v-if="previewUrl"
        :src="previewUrl"
        style="width: 100%; height: 600px; border: 1px solid #d9d9d9"
      ></iframe>
      <div v-else style="text-align: center; padding: 50px">
        <a-icon type="file-pdf" style="font-size: 48px; color: #999" />
        <p style="margin-top: 16px; color: #999">无法加载PDF预览</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'

export default {
  name: 'PdfUpload',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      fileList: [],
      previewVisible: false,
      previewUrl: '',
    }
  },
  watch: {
    value: {
      deep: true,

      handler(newVal) {
        this.updateFileList(newVal)
      },

      immediate: true,
    },
  },
  methods: {
    updateFileList(url) {
      if (url) {
        this.fileList = [
          {
            uid: '-1',
            name: this.getFileName(url),
            status: 'done',
            url: url,
          },
        ]
      } else {
        this.fileList = []
      }
    },
    getFileName(url) {
      if (!url) return '文件.pdf'
      const parts = url.split('/')
      return parts[parts.length - 1] || '文件.pdf'
    },
    beforeUpload(file) {
      // 检查文件类型
      const isPdf =
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf')
      if (!isPdf) {
        this.$message.error('只能上传PDF文件！')
        return false
      }
      // 检查文件大小（限制50MB）
      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('PDF文件大小不能超过50MB！')
        return false
      }
      return true
    },
    async handleChange(info) {
      this.loading = true
      new UploadFileToOSS([info.file], {
        finally: (res) => {
          this.loading = false
          if (res && res.length > 0) {
            const fileUrl = res[0].path || res[0].url
            this.fileList = [
              {
                uid: res[0].uid || Date.now().toString(),
                name: res[0].name || info.file.name,
                status: 'done',
                url: fileUrl,
              },
            ]
            $emit(this, 'change', fileUrl)
            this.$message.success('上传成功')
          } else {
            this.$message.error('上传失败')
          }
        },
      })
    },
    changeFile(info) {
      // 处理文件列表变化
      if (info.file.status === 'removed') {
        this.fileList = []
        $emit(this, 'change', '')
      }
    },
    handleRemove(file) {
      return new Promise((resolve) => {
        this.$confirm({
          title: '确认删除',
          content: '确定要删除这个PDF文件吗？',
          onOk: () => {
            this.fileList = []
            $emit(this, 'change', '')
            resolve(true)
          },
          onCancel: () => {
            resolve(false)
          },
        })
      })
    },
    handlePreview(file) {
      const url = file.url || file.response?.url || file.originFileObj?.url
      if (url) {
        // 如果是PDF文件，使用iframe预览
        if (
          url.toLowerCase().endsWith('.pdf') ||
          file.type === 'application/pdf' ||
          (file.name && file.name.toLowerCase().endsWith('.pdf'))
        ) {
          // 使用Google Docs Viewer作为备用方案，如果直接预览失败
          // 直接使用URL，浏览器会尝试预览
          this.previewUrl = url
          this.previewVisible = true
        } else {
          // 如果不是PDF，尝试直接打开
          window.open(url, '_blank')
        }
      } else {
        this.$message.warning('无法预览该文件')
      }
    },
    handleCancel() {
      this.previewVisible = false
      this.previewUrl = ''
    },
    openInNewWindow() {
      if (this.previewUrl) {
        window.open(this.previewUrl, '_blank')
      }
    },
  },
  emits: ['change', 'update:value', , , 'update:value'],
}
</script>

<style scoped>
.pdf-upload {
  width: 100%;
}
</style>
